export const FORM_FIELDS_NAMES = {
    SEARCH_BY_DATE: 'searchByDate',
    SEARCH_BY_PATIENT: 'searchByPatient',
    SEARCH_BY_STATUS: 'searchByStatus'
}